import React from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { IconTrashFilledMedium, colors, spacing } from "@izettle/otto"
import { Text, IconButton } from "@izettle/react"

import PDFImageAsset from "@/assets/PDF.png"
import { useThemeInfo } from "@/hooks/use-theme-info"

const Item = styled.li``
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${spacing.none};
  padding: ${spacing.xxSmall} ${spacing.none};
`

const PreviewImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin: ${spacing.none} ${spacing.xxSmall} ${spacing.none} ${spacing.none};
`

const PreviewName = styled(Text.Regular)`
  flex: 1;
  margin: ${spacing.none};
  overflow: hidden;
  text-overflow: ellipsis;
`

const RemoveIconButton = styled(IconButton)<{ paypalTheme : boolean}>`
  margin-left: auto;
  color: ${({paypalTheme}) => paypalTheme ? colors.icon.error.small : colors.icon.action }; 
  &:hover {
    cursor: pointer;
  }
`

type PreviewItemProps = {
  file: File
  removeFile: (name: string) => void
}

export const PreviewItem: React.FC<PreviewItemProps> = ({ file, removeFile }) => {
  const { text } = useLocalization()
  const {paypalTheme} = useThemeInfo()
  const imageSrc =
    file.type === "application/pdf" ? PDFImageAsset : URL.createObjectURL(file)

  return (
    <Item role="listitem" key={file.name}>
      <ItemWrapper>
        <PreviewImage src={imageSrc} alt="" aria-hidden />
        <PreviewName>{file.name}</PreviewName>
        <RemoveIconButton
          title={text("GENERIC_DOC_UPLOAD_REMOVE_FILE_BUTTON")}
          svgIcon={IconTrashFilledMedium}
          variant="primary"
          paypalTheme={paypalTheme}
          onClick={() => removeFile(file.name)}
        />
      </ItemWrapper>
    </Item>
  )
}
